enum ShopActions {
    // Einstellungen — Kategorien //
    FETCH_CATEGORIES = "shopFetchCategories",
    GET_CATEGORY = "shopGetCategory",
    CREATE_CATEGORY = "shopCreateCategory",
    UPDATE_CATEGORY = "shopUpdateCategory",
    DELETE_CATEGORY = "shopDeleteCategory",
    // Einstellungen — Lookups //
    FETCH_DELIVERY_OPTIONS = "shopFetchDeliveryOptions",
    FETCH_COUNTRIES = "shopFetchCountries",
    FETCH_ORDER_STATES = "shopFetchOrderStates",
    FETCH_STORAGES = "shopFetchStorages",
    // Einstellungen — Lieferoptionen CRUD //
    CREATE_DELIVERY_OPTION = "shopCreateDeliveryOption",
    UPDATE_DELIVERY_OPTION = "shopUpdateDeliveryOption",
    DELETE_DELIVERY_OPTION = "shopDeleteDeliveryOption",
    // Einstellungen — Bestellstatus CRUD //
    CREATE_ORDER_STATE = "shopCreateOrderState",
    UPDATE_ORDER_STATE = "shopUpdateOrderState",
    DELETE_ORDER_STATE = "shopDeleteOrderState",
    // Einstellungen — Lager CRUD //
    CREATE_STORAGE = "shopCreateStorage",
    UPDATE_STORAGE = "shopUpdateStorage",
    DELETE_STORAGE = "shopDeleteStorage",
    // Einstellungen — Länder CRUD //
    CREATE_COUNTRY = "shopCreateCountry",
    UPDATE_COUNTRY = "shopUpdateCountry",
    DELETE_COUNTRY = "shopDeleteCountry",
    // Einstellungen — Attribute CRUD //
    FETCH_ATTRIBUTES = "shopFetchAttributes",
    CREATE_ATTRIBUTE = "shopCreateAttribute",
    UPDATE_ATTRIBUTE = "shopUpdateAttribute",
    DELETE_ATTRIBUTE = "shopDeleteAttribute",
    // Einstellungen — Facetten CRUD //
    FETCH_FACETTES = "shopFetchFacettes",
    CREATE_FACETTE_MAIN = "shopCreateFacetteMain",
    UPDATE_FACETTE_MAIN = "shopUpdateFacetteMain",
    DELETE_FACETTE_MAIN = "shopDeleteFacetteMain",
    CREATE_FACETTE_SUB = "shopCreateFacetteSub",
    UPDATE_FACETTE_SUB = "shopUpdateFacetteSub",
    DELETE_FACETTE_SUB = "shopDeleteFacetteSub",
    // Einstellungen — Inhaltsstoffe CRUD //
    FETCH_INGREDIENTS = "shopFetchIngredients",
    CREATE_INGREDIENT = "shopCreateIngredient",
    UPDATE_INGREDIENT = "shopUpdateIngredient",
    DELETE_INGREDIENT = "shopDeleteIngredient",
    UPDATE_INGREDIENT_HEALTHCLAIMS = "shopUpdateIngredientHealthclaims",
    // Einstellungen — Health Claims CRUD //
    FETCH_HEALTHCLAIMS = "shopFetchHealthclaims",
    CREATE_HEALTHCLAIM = "shopCreateHealthclaim",
    UPDATE_HEALTHCLAIM = "shopUpdateHealthclaim",
    DELETE_HEALTHCLAIM = "shopDeleteHealthclaim",
}

enum ShopMutation {
    SET_CATEGORIES = "shopSetCategories",
    SET_DELIVERY_OPTIONS = "shopSetDeliveryOptions",
    SET_ORDER_STATES = "shopSetOrderStates",
    SET_STORAGES = "shopSetStorages",
    SET_COUNTRIES = "shopSetCountries",
    SET_ATTRIBUTES = "shopSetAttributes",
    SET_FACETTES = "shopSetFacettes",
    SET_INGREDIENTS = "shopSetIngredients",
    SET_HEALTHCLAIMS = "shopSetHealthclaims",
}

export {ShopActions, ShopMutation};
